package kz.dentalcrm.app.screens.main.mvi

import kz.dentalcrm.app.core.base.ViewState

data class MainState(
    val selectedTabIndex: Int = 0
) : ViewState
